<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dark: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: 360
    }
  },
  data: function() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        events: [],
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          xAxes: [
            {
              labels: Array.from(Array(84), (x, i) => i),
              offset: true,
              scaleLabel: {
                display: false
              },
              gridLines: {
                display: false,
                offsetGridLines: true,
                color: this.darkLight(),
                zeroLineColor: this.darkLight(),
                drawOnChartArea: false,
                tickMarkLength: -4
              },
              ticks: {
                display: false,
                min: 0,
                max: 84,
                beginAtZero: false,
                stepSize: 12,
                // maxRotation: 10,
                padding: 12,
                fontSize: 12,
                fontColor: this.darkLight(),
                callback: function(dataLabel, index) {
                  // Show only labels divisible by 12
                  if (index % 12 === 0) {
                    let day = "";
                    switch (index) {
                      case 0:
                        day = "Sunday";
                        break;
                      case 12:
                        day = "Monday";
                        break;
                      case 24:
                        day = "Tuesday";
                        break;
                      case 36:
                        day = "Wednesday";
                        break;
                      case 48:
                        day = "Thursday";
                        break;
                      case 60:
                        day = "Friday";
                        break;
                      case 72:
                        day = "Saturday";
                        break;
                      default:
                        day = "";
                        break;
                    }
                    // console.log(day);
                    return day;
                  }
                  return null;
                }
              }
            }
          ],
          yAxes: [
            {
              display: false,
              beginAtZero: true
            }
          ]
        },
        elements: {
          line: {
            fill: null,
            borderWidth: 1,
            borderColor: this.darkLight()
          },
          point: {
            pointStyle: "rect",
            borderWidth: 2
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  methods: {
    darkLight() {
      if (this.dark) {
        return "#FFFFFF";
      } else {
        return "#000000";
      }
    }
  }
};
</script>
